export default "__VITE_ASSET__B3apUb7a__"